export default "__VITE_ASSET__Bou24AYa__"